"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDropdownSelect = void 0;
var _DropdownSelect = require("./DropdownSelect");
// TODO: in v9, move styled() from DropdownSelect.jsx to here
var StyledDropdownSelect = _DropdownSelect.DropdownSelect;
exports.StyledDropdownSelect = StyledDropdownSelect;